import { AccountHeartOutlineIcon } from './AccountHeartOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 66013F5C-F7FD-4974-AB80-E624C3E0A5E9
 * name account-heart-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-heart-outline.svg
 * tags
 * - Account / User 
 * - Medical / Hospital 
 */
export const PersonHeartOutlineIcon = AccountHeartOutlineIcon;
export default PersonHeartOutlineIcon